<template>
  <v-container fluid pt-0>
    <v-row align="center" class="pb-2">
      <h1 class="headline">Email Types</h1>

      <v-spacer></v-spacer>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn v-on="on" fab dark color="primary" @click="onCreateNew">
            <v-icon dark>mdi-plus</v-icon>
          </v-btn>
        </template>
        <span>Create New Email Type</span>
      </v-tooltip>
    </v-row>
    <v-row>
      <v-col class="pa-0">
        <v-data-table
          :headers="headers"
          :items="items"
          :loading="$apollo.loading"
          item-key="id"
          class="elevation-1"
          v-bind="pagingOptions"
          mobile-break-point="1264"
        >
          <template v-slot:item.actions="{ item }">
            <default-list-actions
              :item="item"
              hideView
              @editItem="onEditItem"
              @deleteItem="onDeleteItem"
            ></default-list-actions>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <email-type-dialog
      :show="showDialog"
      v-model="editedItem"
      @close="showDialog = false"
      @input="onSave"
    ></email-type-dialog>
  </v-container>
</template>

<script>
import DefaultListActions from "../../shared/DefaultListActions.vue";
import { ListMixin } from "../../../../mixins/ListMixin";
import gql from "graphql-tag";
import { removeGQLTypename } from "../../../../helpers";
import EmailTypeDialog from "./EmailTypeDialog.vue";
const EMAIL_TYPES = gql`
  query allEmailTypes {
    emailTypes {
      totalCount
      edges {
        node {
          id
          name
          description
          subject
          template
          isPrivate
        }
      }
    }
  }
`;
const UPDATE_MUTATION = gql`
  mutation updateEmailType($input: EmailTypeInput!) {
    updateEmailType(input: $input) {
      id
      name
      description
      subject
      template
      isPrivate
    }
  }
`;
const CREATE_MUTATION = gql`
  mutation createEmailType($input: EmailTypeInput!) {
    createEmailType(input: $input) {
      id
      name
      description
      subject
      template
      isPrivate
    }
  }
`;
const DELETE_MUTATION = gql`
  mutation deleteEmailType($id: ID!) {
    deleteEmailType(id: $id) {
      id
    }
  }
`;
export default {
  name: "email-types",
  mixins: [ListMixin],
  components: { DefaultListActions, EmailTypeDialog },

  data() {
    return {
      debug: false,
      headers: [
        {
          text: "Name",
          value: "name",
          name: "name",
        },
        {
          text: "Description",
          value: "description",
          name: "description",
        },
        {
          text: "Actions",
          value: "actions",
          sortable: false,
          name: "actions",
          align: "center",
        },
      ],
      showDialog: false,
      editedItem: null,
    };
  },

  computed: {
    items() {
      return this.emailTypes && this.emailTypes.edges
        ? this.emailTypes.edges.map(removeGQLTypename)
        : [];
    },
  },

  methods: {
    onCreateNew() {
      //console.log("creating new email type");
      this.editedItem = null;
      this.showDialog = true;
    },
    onEditItem(payload) {
      this.editedItem = { ...payload };
      this.showDialog = true;
    },
    onSave(payload) {
      this.showDialog = false;
      this.$apollo
        .mutate({
          mutation: payload.id ? UPDATE_MUTATION : CREATE_MUTATION,
          variables: { input: { ...payload } },
          refetchQueries: [
            {
              query: EMAIL_TYPES,
            },
          ],
        })
        .then(() => {
          this.$store.dispatch("showAppSnackbar", {
            msg: "Email Type Saved.",
          });
        })
        .catch((err) => {
          const errorMsg = err.graphQLErrors.map((e) => e.message).join(", ");
          this.$store.dispatch("showAppSnackbar", {
            msg: errorMsg,
            color: "error",
          });
        });
    },
    onDeleteItem(payload) {
      this.$apollo
        .mutate({
          mutation: DELETE_MUTATION,
          variables: {
            id: payload.id,
          },
          refetchQueries: [
            {
              query: EMAIL_TYPES,
            },
          ],
        })
        .then(() => {
          this.$store.dispatch("showAppSnackbar", {
            msg: "Email Type Removed.",
          });
        })
        .catch((err) => {
          const errorMsg = err.graphQLErrors.map((e) => e.message).join(", ");
          this.$store.dispatch("showAppSnackbar", {
            msg: errorMsg,
            color: "error",
          });
        });
    },
  },

  apollo: {
    emailTypes: {
      query: EMAIL_TYPES,
      variables() {
        return {
          after: this.after,
          filter: this.searchParams,
          sort: this.sort,
        };
      },
      fetchPolicy: "network-only",
      result({ data }) {
        this.totalItems = data.emailTypes.totalCount;
      },
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/admin/contents/EmailTypes.vue